export interface SystemConfig {
	id: string;
	nome: string;
	valor: string;
	tipo: string;
	descricao: string;
}